/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-insurances
 * crm-screener-insurances
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { PalAuthSubmission } from './PalAuthSubmission';
import {
    PalAuthSubmissionFromJSON,
    PalAuthSubmissionFromJSONTyped,
    PalAuthSubmissionToJSON,
} from './PalAuthSubmission';

/**
 * 
 * @export
 * @interface UpdatePalAuthSubmission200Response
 */
export interface UpdatePalAuthSubmission200Response {
    /**
     * 
     * @type {PalAuthSubmission}
     * @memberof UpdatePalAuthSubmission200Response
     */
    data?: PalAuthSubmission;
}

/**
 * Check if a given object implements the UpdatePalAuthSubmission200Response interface.
 */
export function instanceOfUpdatePalAuthSubmission200Response(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function UpdatePalAuthSubmission200ResponseFromJSON(json: any): UpdatePalAuthSubmission200Response {
    return UpdatePalAuthSubmission200ResponseFromJSONTyped(json, false);
}

export function UpdatePalAuthSubmission200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdatePalAuthSubmission200Response {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'data': !exists(json, 'data') ? undefined : PalAuthSubmissionFromJSON(json['data']),
    };
}

export function UpdatePalAuthSubmission200ResponseToJSON(value?: UpdatePalAuthSubmission200Response | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'data': PalAuthSubmissionToJSON(value.data),
    };
}

